const n = () => {
  const o = Node.prototype.removeChild;
  Node.prototype.removeChild = function(e) {
    if (e.parentNode === this)
      return o.apply(this, arguments);
  };
  const r = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function(e, t) {
    if (!(t && t.parentNode !== this))
      return r.apply(this, arguments);
  };
};
export {
  n as default
};
